import type { FormQuestion, FormPage } from '@kushya/shared';

export { evaluatePageJump, findPageIndexForQuestion, findPageIndexForTarget } from './pageJump';

export const sortPages = (pages: FormPage[]) =>
  [...pages].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export function getPageIds(
  orderedPages: FormPage[],
  hasUnassignedQuestions: boolean,
): string[] {
  const ids = orderedPages.map((page) => page.id);
  if (hasUnassignedQuestions) {
    ids.push('__unassigned');
  }
  return ids;
}

export function getPageQuestions(
  questions: FormQuestion[],
  unassignedQuestions: FormQuestion[],
  pageId: string | null | undefined,
): FormQuestion[] {
  if (pageId === '__unassigned') {
    return unassignedQuestions;
  }
  if (!pageId) {
    return [];
  }
  return questions.filter((question) => question.pageId === pageId);
}

export function getStepIndexForPageIndex(
  pageIndex: number,
  pageIds: string[],
  getQuestionsForPage: (pageId: string | null | undefined) => FormQuestion[],
): number {
  let count = 0;
  for (let i = 0; i < pageIndex; i += 1) {
    count += getQuestionsForPage(pageIds[i]).length;
  }
  return count;
}
